import { render, staticRenderFns } from "./Card4.vue?vue&type=template&id=2072b72a&scoped=true&"
import script from "./Card4.vue?vue&type=script&lang=js&"
export * from "./Card4.vue?vue&type=script&lang=js&"
import style0 from "./Card4.vue?vue&type=style&index=0&id=2072b72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072b72a",
  null
  
)

export default component.exports